import React from "react";
// import KeciorenSidebar from "../Sidebar/KeciorenSidebar";
// import KeciorenOtherServices from "../ServiceAreas/KeciorenServiceAreas";
import BadgeSection from "../../BadgeSection";

const KeciorenIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      {/* Breadcrumb */}
      <div className="text-sm text-gray-600 mb-4">
        <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmet Bölgeleri</span> &nbsp;&gt;&nbsp; Keçiören
      </div>

      {/* Başlık */}
      <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">KEÇİÖREN HALI VE KOLTUK YIKAMA</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* Sol sidebarlar */}
        <div className="space-y-6">
          {/* <KeciorenSidebar />
          <KeciorenOtherServices /> */}
        </div>

        {/* İçerik */}
        <div className="md:col-span-2 space-y-6">
          <p>
            **Keçiören’de hijyenik ve profesyonel halı-koltuk yıkama hizmetleriyle temizlik konforunu evinize getiriyoruz!**  
           Abone Halı Yıkama olarak, **derinlemesine temizlik ve hijyen garantisi** sağlıyoruz.
          </p>

          <p>
            **Keçiören’in tüm mahallelerinde mobil servisimiz** ile **yerinden alım ve teslimat** hizmeti sunuyoruz.  
            **Bağlum, Etlik, Şehit Kubilay, Sanatoryum, Kalaba, 19 Mayıs** gibi bölgelerde **hızlı temizlik çözümleri** sağlıyoruz.
          </p>

          <h2 className="text-lg font-semibold text-[#003132]">Keçiören'de NedenAbone Halı Yıkama?</h2>
          <ul className="list-disc list-inside">
            <li>**Özel buhar ve vakum sistemleri** – Derinlemesine temizlik</li>
            <li>**Antibakteriyel ve hijyen garantisi** – Sağlıklı ortam sağlıyoruz</li>
            <li>**Leke çıkarma garantisi** – En zorlu lekeler bile temizlenir</li>
            <li>**Halı ve koltuk kumaşına zarar vermeyen sistemler**</li>
            <li>**Yerinde yıkama & fabrikada derinlemesine yıkama** seçenekleri</li>
          </ul>

          <p>
            **Mobil servis sayesinde** Keçiören’in **her bölgesine hızlı hizmet** sunuyoruz.  
            Buhar ve vakum teknikleriyle yapılan temizlik, **kir ve alerjenleri tamamen yok eder**.
          </p>

          <p>
            **Ev tekstili yıkama hizmetleri:**  
            Yorgan, perde, battaniye gibi ürünleri **antibakteriyel yıkama** ile temizleyerek evinizde daha sağlıklı bir ortam sağlıyoruz.
          </p>

          <p>
            **Keçiören'in her bölgesine zahmetsiz temizlik garantisiyle hizmet veriyoruz!**  
            Hemen <strong>İletişim</strong> sayfamızdan bize ulaşarak sipariş verebilir veya fiyat bilgisi alabilirsiniz!
          </p>
        </div>

        {/* Rozetler */}
        <div className="space-y-6">
          <BadgeSection />
        </div>
      </div>
    </div>
  );
};

export default KeciorenIntro;
